import { Injectable } from '@angular/core';
import { BaseService } from '@base/base.service';
import { Pro } from '../models/pro.model';

@Injectable()
export class ProService extends BaseService<Pro> {
  serviceUrl = '/api/pro';
}
